export function ExternalScripts() {
	// Ignore in non-prod environments
	if (import.meta.env.PUBLIC_ENV !== "production") {
		return null;
	}

	return <script src="/external.js" async />;
}
